// @ts-nocheck
import { useLazyQuery, useMutation } from "@apollo/client";
import { memo, useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState } from "recoil";
import pathState from "../../../../atoms/pathstate";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  AddLicenseeMasterByID,
  CREATE_LICENSEE,
  DELETE_LICENSEE_MASTER,
  EDIT_LICENSEE,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import "./AddLicense.scss";

const AddLicense = ({
  show,
  id,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  onKeyDown,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Licensee Master");
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [FormData, setFormdata] = useState({});
  const Form_Key = "Licensee_Master";
  const formRef = useRef({});
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Licensee_Master?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState<any>({});
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const [{ CurrentTitle }] = useRecoilState(pathState);

  // Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreateLicensee, { loading: CreateLicenseeMaster, error }] = useMutation(CREATE_LICENSEE);

  const [GetDataByID] = useLazyQuery(AddLicenseeMasterByID, {
    fetchPolicy: "network-only",
  });

  const [editLicencee, { loading: EditLicenceeMaster }] = useMutation(EDIT_LICENSEE);

  const [deleteLicencee, { loading: DeleteLicenceeMaster }] = useMutation(DELETE_LICENSEE_MASTER);

  const LicenseeMasterLoadingState =
    CreateLicenseeMaster || EditLicenceeMaster || DeleteLicenceeMaster;

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Licensee_Master?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (modifiedTypeOfPortal !== "Edit Licensee Master" || TypeOfPortal !== "Edit") {
      getFormSectionAndFields().then(() => {
        GetDataByID({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          const resdata = data?.GetLicenseeByID;
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Account_ID: resdata?.Account_ID_Data,
              },
            },
          });
          setAllFieldsData({ ...resdata, Account_ID: resdata?.Account_ID_Data?.Business_Name });
          updateValueForm(formRef, { ...resdata, Account_ID: resdata?.Account_ID_Data?.Business_Name });
        });
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const submit = async (close) => {
    let Name = (ReferenceFieldName as { name: string }[])[0]?.name;
    let data = { ...FormData };

    data["Account_ID"] = FormDataFromRedux?.MasterData[Form_Key]?.Account_ID?._id;
    if (modifiedTypeOfPortal === "Edit Licensee Master") {
      await editLicencee({
        variables: { id: allFieldsData?._id, userInput: data },
      })
        .then((res) => {
          SuccessToast("Licensee Master Editted Successfully");
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.editLicencee,
              },
            },
          });
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else if (modifiedTypeOfPortal === "Delete Licensee Master") {
      const ArrayOfID = selectedRows.map((obj: any) => obj._id);
      await deleteLicencee({
        variables: { idsToDelete: ArrayOfID },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Licensee Master Deleted");
          settoggle(false);
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      delete data["Business_City"];
      delete data["Business_State"];
      delete data?.["Upload Image"];

      await CreateLicensee({
        variables: {
          createInput: data,
        },
      })
        .then((res) => {
          if (CurrentTitle === Form_Key) {
            dispatch({ type: "Refetch", payload: true });
          }
          SuccessToast("Licensee Added");
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.CreateLicencee,
              },
            },
          });
          if (close === "Close") {
            Closeformfunction();
          }
          setAllFieldsData({});
          handleFormReset(formRef);
          dispatch({ type: "ClearData", payload: { data: {} } });
        })
        .catch((err) => {
          settoggle(toggle);
          ErrorToast(err.message);
        });
    }
    if (error) {
      ErrorToast(error.message);
    }
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    dispatch({ type: "ClearData", payload: { data: {} } });
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  if (modifiedTypeOfPortal === "Delete Licensee Master") {
    return (
      <Reactportal
        open={toggle}
        onClose={() => settoggle(false)}
        TypeOfPortal={"Confirm"}
      //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={LicenseeMasterLoadingState}
        />
      </Reactportal>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={submit}
      submitType={submitType}
      SaveAndClose={TypeOfPortal === "Add" ? SaveAndCloseForAdd : submit}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={LicenseeMasterLoadingState}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
        >
          <div className="formContainer">
            {inputFields && inputFields?.length > 0 ? (
              inputFields?.map((e, i) => (
                <div key={e.id} className="FormSectionParent">
                  <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                  <div className="FormSection twosectionsinsidecontainer">
                    <FormInputSectionComponent
                      accountId=""
                      inputfields={e.fields}
                      Type={e.name}
                      fielddata={allFieldsData}
                      formkey={Form_Key}
                      formRef={formRef}
                      onhandleFormikChange={HanldeChangeonForm}
                    />
                  </div>
                </div>
              ))
            ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
              <p>No form fields available.</p>
            ) : null}
          </div>
        </Reactportal>
      </div>
    </>
  );
};

export default memo(AddLicense);
